import { Button, Modal, Space } from "@pankod/refine-antd";

type FirstAccessWhatsappConfirmationModalProps = {
  visible: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const FirstAccessWhatsappConfirmationModal: React.FC<
  FirstAccessWhatsappConfirmationModalProps
> = ({ visible, loading = false, onCancel, onConfirm }) => {
  if (!visible) {
    return null;
  }

  return (
    <Modal
      visible={visible}
      title="Confirmar reenvio da mensagem"
      footer={null}
      onCancel={loading ? undefined : onCancel}
      destroyOnClose
    >
      <p className="first-access-whatsapp-modal-message">
        Deseja reenviar a mensagem de primeiro acesso via WhatsApp?
      </p>

      <Space
        className="first-access-whatsapp-modal-actions"
        size={12}
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button disabled={loading} onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          type="primary"
          loading={loading}
          disabled={loading}
          onClick={onConfirm}
        >
          Confirmar envio
        </Button>
      </Space>
    </Modal>
  );
};
